export default {
      id: "i-research-team-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-research-team",
      toString: function () {
        return this.url;
      }
    }